import React, { useEffect, useRef } from "react";
import classNames from "classnames";
import classes from "./StepHeader.scss";
import _ from "lodash";
import { onEnterOrSpaceKeyDown } from "Utils";

const StepHeader = React.memo(props => {
  const {
    steps,
    currentStep,
    testId,
    onClickStep,
    isStepsClickable = false,
  } = props;

  const currentStepRef = useRef(null); // Reference for the current step button

  useEffect(() => {
    if (currentStepRef.current) {
      currentStepRef.current.focus();
    }
  }, [currentStep]);

  const handleClick = value => {
    onClickStep(value);
  };

  return (
    <div className={classes.container}>
      {_.map(steps, step => {
        const { label, value } = step;
        const isActiveStep = value === currentStep;

        const stepClass = classNames(classes.step, {
          [classes.activeStep]: isActiveStep,
          [classes.stepDisabled]: isStepsClickable,
        });

        return (
          <div
            className={stepClass}
            key={value}
            data-test-id={`${testId}-stepHeader-${_.camelCase(label)}-button`}
            onClick={() => handleClick(value)}
            ref={isActiveStep ? currentStepRef : null}
            tabIndex={0}
            onKeyDown={e => {
              onEnterOrSpaceKeyDown(e, () => handleClick(value));
            }}
          >
            {label}
          </div>
        );
      })}
    </div>
  );
});

StepHeader.displayName = "StepHeader";
StepHeader.defaultProps = {
  testId: "appComponents",
};

export default StepHeader;
